<template>
    <Dialog
            v-model="show"
            :title="getTitle"
            :show-close-button="true"
            :options="{ width: '45%', height: '95%' }"
            :buttons="buttons"
    >
        <div class="grid-dialog-3">
            <!-- Todos os campos dinâmicos (incluindo nomes das permissões) -->
            <div v-for="(field, i) in allFields" :key="`field-${i}`" class="input-wrapper-dialog">
                <component
                        :is="getComponentType(field)"
                        v-model="dynamicFields[field.model]"
                        v-bind="field.props"
                        outlined dense
                        :rows="getRows(field)"
                        auto-grow="false"
                        v-if="shouldRenderField(field)"
                        v-input-filter="field.isPermissionName && field.type === 'input' ? [$filters.textnumeric] : undefined"
                        maxlength="255"
                        :rules="formSubmitted ? [$rules.required] : []"
                >

                    <!-- Botões de adicionar/remover apenas para campos de nome de permissão -->
                    <template v-if="field.isPermissionName" v-slot:append>
                        <v-btn
                                v-if="field.isLast && permissionNameCount < maxBlocks && !isEdit"
                                icon small
                                class="btn-permissao btn-centered"
                                style="align-self: center;"
                                @click="addPermissionName"
                        >
                            <v-icon small color="white">mdi-plus</v-icon>
                        </v-btn>
                        <v-btn
                                v-if="permissionNameCount > 1 && !isEdit"
                                icon small color="error"
                                class="btn-centered"
                                @click="removePermissionName(field.index)"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </component>
            </div>
        </div>

        <v-divider class="mt-4 mb-4"></v-divider>

        <div v-if="checkboxes.length" class="section-title-check">
            Funcionalidades Administrativas
        </div>

        <div class="checkbox-container-dialog">
            <div
                    v-for="(column, colIndex) in partitionCheckboxColumns"
                    :key="`col-${colIndex}`"
                    class="checkbox-column-dialog"
            >
                <v-checkbox
                        v-for="(chk, i) in column"
                        :key="`${colIndex}-${i}`"
                        v-model="checkedItems"
                        :label="chk.label"
                        :value="chk.value"
                        color="secondary"
                        hide-details
                        dense
                />
            </div>
        </div>
    </Dialog>
</template>

<script>
  export default {
    name: 'DialogPermissoesPerfil',
    props: {
      value: Boolean,
      title: { type: String, default: '' },
      schema: { type: Array, default: () => [] },
      checkboxes: { type: Array, default: () => [] },
      maxBlocks: { type: Number, default: 4 },
      isEdit: { type: Boolean, default: false },
      perfil: { type: Object, default: null }
    },
    data () {
      return {
        permissionNameCount: 1,
        dynamicFields: {
          status: 0
        },
        checkedItems: [],
        formSubmitted: false
      }
    },
    computed: {
      show: {
        get () { return this.value },
        set (val) { this.$emit('input', val) }
      },
      buttons () {
        return {
          [this.isEdit ? 'EDITAR' : 'CRIAR']: {
            handler: this.onConfirm,
            disabled: !this.formValido
          }
        }
      },
      getTitle () {
        if (this.title) return this.title
        return this.isEdit ? 'Editar Permissões' : 'Adicionar Permissões'
      },
      allFields () {
        const fields = []

        for (let i = 0; i < this.permissionNameCount; i++) {
          fields.push({
            type: 'input',
            model: `permissionName_${i}`,
            props: { label: 'Nome da Permissão' },
            isPermissionName: true,
            isLast: i === this.permissionNameCount - 1,
            index: i
          })
        }

        // add outros campos dinamicos
        this.schema.forEach(field => {
          fields.push({
            ...field,
            isPermissionName: false
          })
        })

        return fields
      },
      // divide  os checkboxes em colunas de 10
      partitionCheckboxColumns () {
        const columns = []
        const itemsPerColumn = 10

        for (let i = 0; i < this.checkboxes.length; i += itemsPerColumn) {
          columns.push(this.checkboxes.slice(i, i + itemsPerColumn))
        }

        return columns
      },
      permissionNames () {
        const names = []
        for (let i = 0; i < this.permissionNameCount; i++) {
          names.push(this.dynamicFields[`permissionName_${i}`] || '')
        }
        return names
      },
      formValido () {
        const nomesPreenchidos = this.permissionNames.length > 0 && this.permissionNames.every(nome => nome && nome.trim())

        // Campos obrigatórios do schema preenchidos
        let camposPreenchidos = true
        this.schema.forEach(field => {
          const val = this.dynamicFields[field.model]
          if (
            val === undefined ||
            val === null ||
            val === '' ||
            (field.type === 'select' && (val === '' || val === null || typeof val === 'undefined'))
          ) {
            camposPreenchidos = false
          }
        })

        // Pelo menos um checkbox marcado
        const checkboxesOk = this.checkedItems && this.checkedItems.length > 0

        return nomesPreenchidos && camposPreenchidos && checkboxesOk
      }
    },
    watch: {
      // Limpa o formulario quando fecha o dialog
      show (newVal) {
        if (newVal && this.perfil) {
          // Preenche campos do schema
          this.dynamicFields = {}

          // Campos do schema (status e perfil)
          this.schema.forEach(field => {
            if (field.model === 'perfil') {
            // Se o perfil relacionado não existir, deixe o campo vazio
            // mas com um placeholder indicando que não há perfil
            this.dynamicFields.perfil =
              this.perfil.perfil_relacionado_id ||
              this.perfil.id_perfil_relacionado ||
              null // Alterado de '' para null
            } else if (field.model === 'status') {
              this.dynamicFields.status = this.perfil.status === true ? 1
                : this.perfil.status === false ? 0 : ''
            } else {
              this.dynamicFields[field.model] = this.perfil[field.model] ?? ''
            }
        })

          let nomes = Array.isArray(this.perfil.perfil_permissao_nomes)
            ? this.perfil.perfil_permissao_nomes
            : [this.perfil.perfil_permissao_nome].filter(Boolean)

          this.permissionNameCount = nomes.length || 1

          for (let i = 0; i < this.permissionNameCount; i++) {
            this.$set(this.dynamicFields, `permissionName_${i}`, nomes[i] || '')
          }

          this.checkedItems = Array.isArray(this.perfil.selectedPermissions)
            ? [...this.perfil.selectedPermissions]
            : []
        }

        if (!newVal) {
          this.permissionNameCount = 1
          this.dynamicFields = {
            status: 0
          }
          this.checkedItems = []
          this.formSubmitted = false
        }
      }
    },
    methods: {
      getComponentType (field) {
        switch (field.type) {
          case 'input': return 'v-text-field'
          case 'select': return 'v-select'
          case 'textarea': return 'v-textarea'
          default: return 'v-text-field'
        }
      },
      getRows (field) {
        return field.type === 'textarea' ? 1 : undefined
      },
      shouldRenderField (field) {
        return !(field.isPermissionName && field.type !== 'input')
      },
      addPermissionName () {
        if (this.permissionNameCount < this.maxBlocks) {
          this.permissionNameCount++
        }
      },
      removePermissionName (index) {
        if (this.permissionNameCount > 1) {
          delete this.dynamicFields[`permissionName_${index}`]

          const values = []
          for (let i = 0; i < this.permissionNameCount; i++) {
            if (i !== index) {
              values.push(this.dynamicFields[`permissionName_${i}`] || '')
            }
            delete this.dynamicFields[`permissionName_${i}`]
          }

          this.permissionNameCount--
          values.forEach((value, i) => {
            this.dynamicFields[`permissionName_${i}`] = value
          })
        }
      },
      onConfirm () {
        this.formSubmitted = true
        if (this.loading) return

        const otherFields = {}
        Object.keys(this.dynamicFields).forEach(key => {
          if (!key.startsWith('permissionName_')) {
            otherFields[key] = this.dynamicFields[key]
          }
        })

        this.$emit('submit', {
          nomes: this.permissionNames,
          fields: otherFields,
          checkboxes: this.checkedItems
        })
      },
      closeDialog () { this.show = false }
    }
  }
</script>

<style scoped>
.grid-dialog-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  align-items: start;
}

/* wrapper para inputs menores */
.input-wrapper-dialog .v-input.v-input--dense .v-input__slot,
.input-wrapper-dialog .v-select.v-input--dense .v-input__slot,
.input-wrapper-dialog .v-textarea.v-input--dense .v-input__slot {
  min-height: 30px !important;
  font-size: 13px;
}

/* ajusta padding interno para inputs e selects */
.input-wrapper-dialog .v-input.v-input--dense .v-input__control,
.input-wrapper-dialog .v-select.v-input--dense .v-input__control,
.input-wrapper-dialog .v-textarea.v-input--dense .v-input__control {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* botão de adicionar com fundo verde */
.btn-permissao {
  background-color: var(--secondary) !important;
  color: white !important;
}
btn-centered {
  align-self: center !important;
  margin-top: -4px !important;
}

/* Alternativa mais específica */
.input-wrapper-dialog .v-input__append-inner .btn-centered {
  margin-top: -6px !important;
  margin-bottom: 2px !important;
}

/* título acima dos checkboxes */
.section-title-check {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #444;
}

/* container dos checkboxes em colunas */
.checkbox-container-dialog {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

/* cada coluna de checkboxes */
.checkbox-column-dialog {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  flex: 1;
}
</style>
